import { DigitizingOrdersApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useDigitizingOrderLogs = () => {
  const [digitizingOrderLogs] = useAPIAction(
    DigitizingOrdersApi,
    async (api, orderId: string) => {
      let response = await api.digitizingOrdersGetDetail({
        id: orderId
      });
      console.log("RESPONSE of API is , ", (response))
      return {
        successMessages: [],
        data: response,
      };
    },
    {
      translationPrefix: "",
    }
  );
  return useCallback(async (orderId: string) => {
    return await digitizingOrderLogs(orderId);
  }, [digitizingOrderLogs]);
};
